/**
 * A utility method to turn arbitrary arguments into a strongly-typed tuple.
 * This helps to solve typing problems like string[] vs [string]
 * @param args A list of arbitrary arguments
 * @returns A strongly typed tuple
 */
export const tuple = <T extends unknown[]>(...args: T): T => args;
